var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isModal)?_c('portal-target',{attrs:{"name":_vm.portalName}}):_vm._t("default"),_vm._v(" "),_c('portal',{attrs:{"to":_vm.portalName}},[_vm._t("toModal")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }